<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    persistent
    max-width="400"
    v-model="loader"
  >
    <v-card>
    	<v-card-title primary-title>
    	  <span class="text-body-1">Lo sentimos, pero no tienes internet en estos momentos</span>
    	</v-card-title>
    	<v-card-title primary-title>
    	  <span class="text-body-1">Activa tu internet para poder continuar</span>
    	</v-card-title>
    </v-card>
  </v-dialog>
</template>


<script>
	export default {
		props:[
			'parametros'
	  ],

	  data: () => ({
	  	loader: true
	  })
	}
</script>